var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.5,
    width: 60,
    height: 60,
    rx: 7,
    fill: "#005587"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4986 30.0099C37.1667 30 42.5 35.3333 42.5 40.6667C42.5 41.7037 41.6934 41.9342 41.3349 41.9854L41.1667 42L19.7876 41.9982L19.6651 41.9854C19.3066 41.9342 18.5 41.7037 18.5 40.6667C18.5 35.3333 23.8333 30 30.4986 30.0099ZM31.3333 32.6667H29.6667C29.3905 32.6667 29.1667 32.8905 29.1667 33.1667V35.3333H27C26.7239 35.3333 26.5 35.5572 26.5 35.8333V37.5C26.5 37.7761 26.7239 38 27 38H29.1667V40.1667C29.1667 40.4428 29.3905 40.6667 29.6667 40.6667H31.3333C31.6095 40.6667 31.8333 40.4428 31.8333 40.1667V38H34C34.2761 38 34.5 37.7761 34.5 37.5V35.8333C34.5 35.5572 34.2761 35.3333 34 35.3333H31.8333V33.1667C31.8333 32.8905 31.6095 32.6667 31.3333 32.6667ZM30.5 15.3333C34.1819 15.3333 37.1667 18.3181 37.1667 22C37.1667 25.6819 34.1819 28.6667 30.5 28.6667C26.8181 28.6667 23.8333 25.6819 23.8333 22C23.8333 18.3181 26.8181 15.3333 30.5 15.3333Z",
    fill: "#80AAC3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.0dc018f9.svg";
export { ForwardRef as ReactComponent };